import { Tenant } from "../types/graphql/generated";

export const isTenantReadOnly = (
  tenant?: Pick<Tenant, "generalConfig"> | null
): boolean => {
  return tenant?.generalConfig?.readOnlyAt
    ? new Date(tenant.generalConfig.readOnlyAt) < new Date()
    : false;
};
